import { TimelineItem } from '@ps/sports-ui-component-library';
import React from 'react';

import { type MarketId, type SelectionId } from '@swf/generated/types/api/sports';
import { useNormalisedEventBasedData } from '@swf/sports/hooks/useNormalisedEventBasedData';
import { getHandicapSelectionValue } from '@swf/sports/utils/getHandicapSelectionValue';

import styles from './PopularBetBuilderItem.scss';

interface Props {
  marketId: MarketId;
  selectionId: SelectionId;
}

const PopularBetBuilderItem: React.FC<Props> = ({ marketId, selectionId }: Props) => {
  const { market } = useNormalisedEventBasedData({ marketId });

  const runner = market?.runners.find((runner) => runner.selectionId === selectionId);

  if (!market || !runner) return null;

  const { runnerName, handicap, resultType } = runner;
  const handicapValue = getHandicapSelectionValue({
    handicap,
    runnerResultType: resultType
  });

  return (
    <TimelineItem>
      <span className={styles.runnerName}>
        {runnerName} {handicapValue ? `(${handicapValue})` : null}
      </span>{' '}
      - {market.marketName}
    </TimelineItem>
  );
};

export default PopularBetBuilderItem;
